import { IconProps } from "./Icons";

export const IconMicOn = ({ width = 32, height = 32 }: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none">
      <rect width={width} height={height} fill="#0033A1" rx={16} />
      <path
        fill="#86A9F6"
        d="M19.75 10a3.75 3.75 0 1 0-7.5 0v6a3.75 3.75 0 1 0 7.5 0v-6Z"
        opacity={0.2}
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M19.75 10a3.75 3.75 0 1 0-7.5 0v6a3.75 3.75 0 1 0 7.5 0v-6ZM16 22.75v3"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M22.712 16.75a6.76 6.76 0 0 1-13.425 0"
      />
    </svg>
  );
};
